import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import bolKraft500 from "@/assets/products/bol-kraft-500ml.jpg";
import bolKraft750 from "@/assets/products/bol-kraft-750ml.jpg";
import bolKraft1000 from "@/assets/products/bol-kraft-1000ml.jpg";
import bolKraft1100 from "@/assets/products/bol-kraft-1100ml.jpg";
import bolKraft1300 from "@/assets/products/bol-kraft-1300ml.jpg";
import bolBlanc500 from "@/assets/products/bol-blanc-500ml.png";
import bolBlanc750 from "@/assets/products/bol-blanc-750ml.jpg";
import bolBlanc1000 from "@/assets/products/bol-blanc-1000ml.jpg";
import bolBlanc1300 from "@/assets/products/bol-blanc-1300ml.jpg";

const config: ProductPageConfig = {
  name: "Saladiers ronds kraft + couvercle rPET",
  breadcrumbName: "Bols kraft",
  subtitle: "Emballage alimentaire recyclable et personnalisable",
  features: ["Contact alimentaire", "Recyclable", "Couvercle rPET inclus", "Disponible en stock", "Personnalisable"],
  variants: [
    {
      ref: "BOL500K", capacity: "500 ml", diameter: "Ø 150 mm", height: "55 mm",
      material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 bols + 200 couvercles", palette: "30 cartons",
      image: bolKraft500,
      availableColors: [{ name: "Kraft", image: bolKraft500 }, { name: "Blanc", image: bolBlanc500 }],
    },
    {
      ref: "BOL750K", capacity: "750 ml", diameter: "Ø 150 mm", height: "70 mm",
      material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 bols + 200 couvercles", palette: "24 cartons",
      image: bolKraft750,
      availableColors: [{ name: "Kraft", image: bolKraft750 }, { name: "Blanc", image: bolBlanc750 }],
    },
    {
      ref: "BOL1000K", capacity: "1000 ml", diameter: "Ø 184 mm", height: "65 mm",
      material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 bols + 200 couvercles", palette: "24 cartons",
      image: bolKraft1000,
      availableColors: [{ name: "Kraft", image: bolKraft1000 }, { name: "Blanc", image: bolBlanc1000 }],
    },
    {
      ref: "BOL1100K", capacity: "1100 ml", diameter: "Ø 184 mm", height: "75 mm",
      material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 bols + 200 couvercles", palette: "16 cartons",
      image: bolKraft1100,
    },
    {
      ref: "BOL1300K", capacity: "1300 ml", diameter: "Ø 184 mm", height: "85 mm",
      material: "Carton kraft + couvercle rPET", packaging: "Carton de 200 bols + 200 couvercles", palette: "16 cartons",
      image: bolKraft1300,
      availableColors: [{ name: "Kraft", image: bolKraft1300 }, { name: "Blanc", image: bolBlanc1300 }],
    },
  ],
  customization: { maxColors: 4, minOrder: "20 000 pièces", bestPrice: "100 000 pièces" },
};

const BolsKraft = () => <ProductPageLayout config={config} />;
export default BolsKraft;
